import FaqListTable from './FaqListTable.component';

export default FaqListTable;